<template>
  <main class="container container-vehicles d-flex flex-column align-items-center">

    <RentComponent :with-driver="this.store.state.order.withDriver" @onSearchSubmit="onSearchSubmit"/>

    <h4 class="pt-5">{{ $t('choose-vehicle.select_a_vehicle') }}</h4>

    <VehicleSelectWrapperComponent ref="vehicleSelectWrapperComponent"></VehicleSelectWrapperComponent>

  </main>
</template>

<script lang="ts">
import './chooseVehicle.scss';

import {defineComponent} from 'vue';
import {useStore} from "vuex";
import axios from "axios";

import apiService from "../../services/apiService";

// @ts-ignore
import RentComponent from "../../components/Forms/Rent/RentComponent.vue";
// @ts-ignore
import VehicleSelectWrapperComponent from "../../components/vehicleSelectWrapper/VehicleSelectWrapperComponent.vue";


export default defineComponent({
  name: 'ChooseVehiclePage',
  components: {
    VehicleSelectWrapperComponent,
    RentComponent
  },
  data() {
    return {}
  },

  setup() {
    const store = useStore();

    return {
      store
    }
  },

  beforeCreate(): void {
    this.store.commit('vehicle/INITIALIZE');
  },

  created() {
    axios.get(apiService.pageChooseVehiclePageEndpoint())
        .then((response) => {
          // ...
        })
        .catch(error => console.error(error));
  },
  mounted() {
    // ...
  },
  methods: {
    onSearchSubmit() {
      // @ts-ignore
      this.$refs.vehicleSelectWrapperComponent.loadVehiclesList();
    }
  }
});
</script>
